import React, { useState, useEffect } from 'react'
import { checkGaurantorcoborrowerByUserId } from '../../AdminActionCreator.component'
import MainNavbar from './MainNavbar'
import MainEdit from './EditUserDetailsAllApplications/Main'
import TabBox from './TabBox'
import LoanDetails from './LoanDetails'
import DetailingLinks from './Links'
import { WEB_URL } from '../../../../../utils/api-factory'

export default function Main({ ediDetailBackHandler, userDetails, admin }) {
    const [viewType, setviewType] = useState("borrower")
    const [subViewType, setSubViewType] = useState("list")
    const [checkTab, setcheckTab] = useState({})
    const [viewIngData, setViewingData] = useState([])
    const [showLinks, setShowLinks] = useState(false)

    useEffect(() => {
        checkGaurantorcoborrowerByUserIdFn(userDetails)
    }, [])

    const handleviewType = (type) => {
        setviewType(type)
        handleSubViewtype("list")
        if (type === "coBorrower") {
            setViewingData(checkTab?.coBorrowers)
        } else if (type === "gaurantor") {
            setViewingData(checkTab?.guarantors)
        } else {
            setViewingData([])
        }
    }

    const handleSubViewtype = (type) => {
        setSubViewType(type)
    }

    const checkGaurantorcoborrowerByUserIdFn = (userDetails) => {
        checkGaurantorcoborrowerByUserId(userDetails?.userId, callback => {
            console.log("call", callback)
            if (callback?.status == 200 && callback?.message == "success") {
                setcheckTab(callback?.data)
            } else {
                setcheckTab({})
            }
        })
    }

    const handleBack = () => {
        if (subViewType == "details") {
            handleSubViewtype("list")
        } else {
            ediDetailBackHandler()
        }
    }

    const tenant = { WEB_URL }

    return (
        <>
            <MainNavbar
                handleBack={handleBack}
                allData={userDetails}
                viewType={viewType}
                handleviewType={handleviewType}
                checkTab={checkTab}
            />
    <div style={{background:"rgb(242, 242, 250)",padding:'30px 10px 0 10px'}}>
            {/* Links toggle pill */}
            {!showLinks && (
                <div style={{ padding: '10px 16px 0' }}>
                    <span
                        onClick={() => setShowLinks(true)}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            cursor: 'pointer',
                            background: '#eef2ff',
                            border: '1.5px solid #c7d2fe',
                            borderRadius: '20px',
                            padding: '5px 14px',
                            fontSize: '13px',
                            fontWeight: '600',
                            color: '#4f46e5',
                            userSelect: 'none',
                            transition: 'background 0.15s ease',
                        }}
                    >
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
                            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
                        </svg>
                        Links
                    </span>
                </div>
            )}

            {/* Expanded Links panel */}
            {showLinks && (
                <DetailingLinks
                    tenant={tenant}
                    allDetail={userDetails}
                    userLinkHandler={(val) => { if (val === 'no') setShowLinks(false) }}
                />
            )}
</div>
            {
                viewType === "borrower" ?
                    <MainEdit
                        userDetails={userDetails}
                        viewType={viewType}
                    />
                    : ''}
            {
                viewType === "loanDetails" ?
                    <LoanDetails
                        userDetails={userDetails}
                    />
                    : ''}

            {
                viewType === "coBorrower" || viewType == "gaurantor" ?
                    <TabBox
                        subViewType={subViewType}
                        handleSubViewtype={handleSubViewtype}
                        viewIngData={viewIngData}
                        viewType={viewType}
                        admin={admin}
                    />
                    : ''}
        </>
    )
}
